import { LinkButton } from '@pmi/dsm-react';
import { ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toastWithAnalytics } from '../../../../../../shared/analytics';
import { toDayMonthYear } from '../../../../../../shared/helpers';
import {
  addInternalAdminResend,
  internalAdminResendList,
} from '../../../resendActionSlice';
import { useResendInternalAdminInvitationMutation } from '../../apiSlice';
import { TableCellProps } from '../../models';

function RegisteredCell({ row }: TableCellProps) {
  const dispatch = useDispatch();
  const [resentInvitation, resendInvitation] =
    useResendInternalAdminInvitationMutation();
  const isInResendList = useSelector(internalAdminResendList).includes(
    row.original.inviteCode,
  );
  const { acceptedDate: dateRegistered } = row.original;
  const onResendClick = (inviteCode: string, email: string) => {
    resentInvitation({
      inviteCode,
    })
      .unwrap()
      .then(() => {
        const message = (): ReactNode => (
          <>
            Invite resent to <span data-exclude-lg="true">{email}</span>
          </>
        );
        toastWithAnalytics(message(), 'success');
        resendInvitation.reset();
      })
      .catch(() => {
        toastWithAnalytics(
          'Could not resend invitation. Please try again.',
          'danger',
        );
      });
  };

  const renderRegisteredDate = () =>
    dateRegistered ? (
      <span>{toDayMonthYear(dateRegistered.toString())}</span>
    ) : (
      <span>30 minutes ago</span>
    );
  return (
    <div
      className="cell d-flex align-items-center"
      key={`registered-${row.original.personId}`}
    >
      {row.original.personId > 0 ? (
        renderRegisteredDate()
      ) : (
        <span className="d-flex align-items-center">
          <span className="d-block me-1">Pending</span>
          {resendInvitation.isLoading ? (
            <Spinner size="sm" className="text-primary ms-1" />
          ) : (
            <LinkButton
              size="xs"
              titleText="Resend"
              className="resendInvite"
              disabled={resendInvitation.isLoading || isInResendList}
              onClick={
                resendInvitation.isLoading || isInResendList
                  ? () => null
                  : () => {
                      dispatch(addInternalAdminResend(row.original.inviteCode));
                      onResendClick(
                        row.original.inviteCode,
                        row.original.invitationEmail,
                      );
                    }
              }
            />
          )}
        </span>
      )}
    </div>
  );
}

export default RegisteredCell;
